<template>
  <v-card>
    <v-card-title>
      <v-layout>
        <v-flex></v-flex>
        <v-flex shrink>
          <v-btn icon @click="$emit('onClose')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text>
      <div class="caption">Title</div>
      <v-text-field
        id="title"
        v-model="input.title"
        v-validate="'required'"
        :name="timestamp"
        data-vv-as="Title"
        outline
        single-line
        placeholder="Title"
        :hide-details="!errors.has(timestamp)"
        :error="errors.has(timestamp)"
        :error-messages="errors.first(timestamp)"
      ></v-text-field>
      <div class="text-xs-center">
        <v-btn color="grey" outline @click="$emit('onClose')">{{ $t('cancel') }}</v-btn>
        <v-btn color="primary" @click="handleSave">{{ $t('Save') }}</v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment'
export default {
  name: 'ReasonRouteManage',
  inject: ['$validator'],
  data() {
    return {
      input: {
        level: undefined,
        name: undefined,
        subReason: [],
        title: ''
      },
      timestamp: moment().format('x')
    }
  },
  methods: {
    handleSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit('onSave', this.input)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/Reason/ReasonRouteManage.vue